import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';

import SelectFilter from 'components/Filters/SelectFilter';
import TreeSelect from 'components/Filters/TreeSelect';
import {default as DateRangeFilter} from 'components/Filters/DateRangeFilter';

import {
  getBookingStatusGroups,
  getBookingStatusesForStatusGroup
} from 'ducks/bookings';

import './styles.css';

const bookingStatusData = getBookingStatusGroups().map(value => ({
  label: value,
  data: getBookingStatusesForStatusGroup(value).map(status => ({
    label: status,
    key: status
  }))
}));

interface RoomProps {
  id: number;
  roomNumber: string;
}

interface BookingTypeProps {
  id: number;
  name: string;
  default: boolean;
  enableOrganisation: boolean;
}

interface RoomTypeProps {
  name: string;
  ref: string;
}

interface RoomTypeFilterProps {
  name: string;
  roomTypes: Array<RoomTypeProps>;
}

interface CreatedByFiltersProps {
  id: number;
  name: string;
}

interface PassedProps {
  locationRef: string;
  getFilters: () => any;
  setFilter: (field: string, value: any) => void;
  clearFilters: () => void;
  bookingTypes: Array<BookingTypeProps>;
  rooms: Array<RoomProps>;
  floors: Array<string>;
  bookingListFilters: {
    roomTypeFilters: Array<RoomTypeFilterProps>;
    createdByFilters: Array<CreatedByFiltersProps>;
  };
}

class BookingsTrackerFilters extends React.Component<PassedProps> {
  render() {
    const {
      setFilter,
      rooms,
      floors,
      bookingTypes,
      bookingListFilters: {roomTypeFilters}
    } = this.props;

    const filters: any = this.props.getFilters();

    const roomTypeData = roomTypeFilters.map(roomTypeGroup => ({
      label: roomTypeGroup.name,
      data: roomTypeGroup.roomTypes.map(roomType => ({
        label: roomType.name,
        key: roomType.ref
      }))
    }));

    const bookingTypesData = bookingTypes.map(bookingType => ({
      label: bookingType.name,
      value: bookingType.name
    }));
    const roomsData = rooms.map(room => ({
      label: room.roomNumber,
      value: room.roomNumber
    }));
    const floorsData = floors.map(floor => ({
      label: floor,
      value: floor
    }));

    return (
      <div className="BookingListFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <TreeSelect
            label="Room Type"
            data={roomTypeData}
            value={filters.roomTypes}
            onFilterChange={roomTypes => {
              setFilter('roomTypes', roomTypes);
            }}
            classNameForTesting="RoomTypeFilter"
          />
          <TreeSelect
            label="Status"
            data={bookingStatusData}
            value={filters.bookingStatuses}
            onFilterChange={bookingStatuses => {
              setFilter('bookingStatuses', bookingStatuses);
            }}
            classNameForTesting="BookingStatusFilter"
          />
          <SelectFilter
            label="Booking Type"
            data={bookingTypesData}
            value={filters.bookingTypes}
            onChange={bookingTypes => setFilter('bookingTypes', bookingTypes)}
            classNameForTesting="BookingTypeFilter"
          />
          <SelectFilter
            label="Room Number"
            data={roomsData}
            value={filters.rooms}
            onChange={rooms => setFilter('rooms', rooms)}
            classNameForTesting="RoomNumberFilter"
          />
          <SelectFilter
            label="Floor"
            data={floorsData}
            value={filters.floors}
            onChange={floors => setFilter('floors', floors)}
            classNameForTesting="FloorFilter"
          />

          <DateRangeFilter
            label="Arrival"
            fieldName="arrival"
            start={filters.arrivalStart}
            end={filters.arrivalEnd}
            onChange={(dateField, date) => setFilter(dateField, date)}
            classNameForTesting="BookingArrivalDatesFilter"
          />
          <DateRangeFilter
            label="Departure"
            fieldName="departure"
            start={filters.departureStart}
            end={filters.departureEnd}
            onChange={(dateField, date) => setFilter(dateField, date)}
            classNameForTesting="BookingDepartureDatesFilter"
          />
        </div>
        <div>
          <Button clear onClick={this.props.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default BookingsTrackerFilters;
